import { classSelectionLabel } from './classSelection.js';

/** Resolve recorded class identity for history; never mutate a saved snapshot. */
export function recordClassIdentity(record = {}, classes = []) {
  const classId = record?.classId;
  const className = record?.className || '';
  const exact = classId && classes.find(cls => cls.id === classId);
  if (exact) return { id: exact.id, classId: exact.id, name: classSelectionLabel(exact) || className || 'Unnamed class', unresolved: false };

  // This is the exact ID made by the former Quick Issue writer. Other unknown
  // IDs remain authoritative; a matching name never replaces them.
  const legacyId = String(className).toLowerCase().trim().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
  if (classId && classId !== legacyId) {
    return { id: classId, classId, name: className || 'Unnamed class', unresolved: false };
  }
  const matches = className ? classes.filter(cls => cls.name === className) : [];
  if (matches.length === 1) {
    const match = matches[0];
    return { id: match.id, classId: match.id, name: classSelectionLabel(match), unresolved: false };
  }
  return {
    id: JSON.stringify(['unmatched-class', className]),
    classId: null,
    name: className ? `${className} · Class not matched` : 'Class not recorded',
    unresolved: true,
  };
}

/** The same groups supply filters, ranked classes and server class counts. */
export function groupRecordsByClass(records = [], classes = []) {
  const groups = new Map();
  for (const record of records) {
    const identity = recordClassIdentity(record, classes);
    const group = groups.get(identity.id) || { ...identity, count: 0 };
    group.count += 1;
    groups.set(identity.id, group);
  }
  return [...groups.values()].sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
}
